export const AUDIO_VOLUME_SLIDER = 'audio-volume-slider';
export const AUDIO_CONTEXT_MENU = 'audio-context-menu';
